import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import Home from './pages/common/Home';
import RegisteredCarriers from './pages/common/RegisteredCarriers';
import CarrierRegistration from './pages/common/CarrierRegistration';
import CarrierBenefits from './pages/common/CarrierBenefits';
import DriverRegister from './pages/common/DriverRegistration';
import DriverBenefits from './pages/common/DriverBenefits';
import Pricing from './pages/common/Pricing';
import AboutUs from './pages/common/AboutUs';
import TruckersForum from './pages/common/TruckersForum';
import News from './pages/common/News';
import ContactUs from './pages/common/ContactUs';
import AdminLogin from './pages/common/AdminLogin';
import CarrierLogin from './pages/common/CarrierLogin';
import DriverLogin from './pages/common/DriverLogin';
import DriverDashboard from './pages/driver/Dashboard';
import AdminDashboard from './pages/admin/Dashboard';
import CarriersListing from './pages/admin/CarrierListing';
import CarrierPendingApproval from './pages/admin/CarrierPendingApproval';
import Packages from './pages/admin/Packages';
import DriversListing from './pages/admin/DriversListing';
import PendingDrivers from './pages/admin/PendingDrivers';
import Reports from './pages/admin/Reports';
import CreatePackage from './pages/admin/CreatePackage';
import EditPackage from './pages/admin/EditPackage';
import CarrierDashboard from './pages/carrier/Dashboard';
import DriverDetail from './pages/carrier/DriverDetail';
import AdminCarriersByIndustry from './pages/admin/CarriersByIndustry';
import CarrierFavourites from './pages/carrier/CarrierFavourites';
import AssignDriver from './pages/admin/AssignDriver';
import ResumePendingApproval from './pages/admin/ResumeApprovalPending';
import AssignedDrivers from './pages/carrier/AssignedDrivers';
import DriverAssign from './pages/admin/DriverAssign';
import PackageSelection from './pages/carrier/PackageSelection';
import PaymentSuccess from './pages/carrier/PaymentSuccess';
import DriverCreate from './pages/admin/DriverCreate';
import Revenue from './pages/admin/Revenue';
import CarrierPackageSelect from './pages/common/CarrierPackageSelectLogin';
import PendingApproval from './pages/admin/PendingApproval';
import HomeBlue from './pages/common/HomeBlue';
import HomeGreen from './pages/common/HomeGreen';
import PackageDetails from './pages/common/PackageDetails';
import WatchFleetyDemo from './pages/carrier/WatchFleetyDemo';
import PrivacyPolicy from './pages/common/PrivacyPolicy';
import CookiePolicy from './pages/common/cookiePolicy';
import TermsOfUse from './pages/common/TermsOfUse';
import CarrierLiveDemo from './pages/carrier/CarrierLiveDemo';
import CarrierDemoBookings from './pages/admin/CarrierDemoBookings';
import PaymentHistory from './pages/carrier/PaymentHistroy';
import ReportIssues from './pages/carrier/ReportIssues';
import ForgotPassword from './pages/common/ForgetPassword';
import ResetPassword from './pages/common/ResetPassword';
import DemoBooking from './pages/common/DemoBooking';
import SalesrepDashboard from './pages/salesrep/Dashboard';
import AdminAddCarrier from './pages/admin/AdminAddCarrier';
import DriverAssignMonitor from './pages/admin/DriverAssignMonitor';
import AdminManagement from './pages/admin/AdminManagement';
import ReportedIssues from './pages/admin/ReportedIssues';
import SpecialPackageDetails from './pages/common/SpecialPackageDetails';
import SpecialPackageAdmin from './pages/admin/SpecialPackageAdmin';
import SpecialPaymentSuccess from './pages/carrier/SpecialPaymentSuccess';
import SpecialPackageSubscribedCarriers from './pages/admin/Specialpackagesubscribedcarriers';

function App() {
    return (
        <SubscriptionProvider>
            <Router basename='/'>
                <div className='App flex flex-col min-h-screen'>
                    <main className='flex-grow'>
                        <Routes>
                            <Route path='/' element={<HomeBlue />} />
                            <Route path='home-blue' element={<Home />} />
                            <Route path='home-green' element={<HomeGreen />} />
                            {/* Carriers */}
                            <Route path='/registered-carriers' element={<RegisteredCarriers />} />
                            <Route path='/carrier-registration' element={<CarrierRegistration />} />
                            <Route path='/carrier-benefits' element={<CarrierBenefits />} />
                            <Route path='carrier/payment-success' element={<PaymentSuccess />} />
                            {/* Drivers */}
                            <Route path='/driver-registration' element={<DriverRegister />} />
                            <Route path='/driver-benefits' element={<DriverBenefits />} />
                            {/* Pricing */}
                            <Route path='/pricing' element={<Pricing />} />
                            <Route path='/package-details/:id' element={<PackageDetails />} />
                            <Route path='/special-package' element={<SpecialPackageDetails />} />
                            {/* Company */}
                            <Route path='/about-us' element={<AboutUs />} />
                            <Route path='/truckers-forum' element={<TruckersForum />} />
                            <Route path='/news' element={<News />} />
                            <Route path='/contact-us' element={<ContactUs />} />
                            {/* Auth */}
                            <Route path='/admin-login' element={<AdminLogin />} />
                            <Route path='/carrier-login' element={<CarrierLogin />} />
                            <Route path='/driver-login' element={<DriverLogin />} />
                            <Route path='/carriers-login' element={<CarrierPackageSelect />} />
                            <Route path='/driver/dashboard' element={<DriverDashboard />} />
                            <Route path='/admin/dashboard' element={<AdminDashboard />} />
                            <Route path='/admin/adminmanagement' element={<AdminManagement />} />
                            <Route path='/admin/carriers-listing' element={<CarriersListing />} />
                            <Route path='/admin/carrier-approval' element={<CarrierPendingApproval />} />
                            <Route path='/admin/resume-approval' element={<ResumePendingApproval />} />
                            <Route path='/admin/packages' element={<Packages />} />
                            <Route path='/admin/special-package' element={<SpecialPackageAdmin />} />
                            <Route path='/admin/drivers-listing' element={<DriversListing />} />
                            <Route path='/admin/drivers-approval' element={<PendingDrivers />} />
                            <Route path='/admin/reports' element={<Reports />} />
                            <Route path='/admin/create-package' element={<CreatePackage />} />
                            <Route path='/admin/package/edit/:id' element={<EditPackage />} />
                            <Route path='/carrier/dashboard' element={<CarrierDashboard />} />
                            <Route path='/carrier/driver-details/:driverId' element={<DriverDetail />} />
                            <Route path='/carrier/favorites' element={<CarrierFavourites />} />
                            <Route path='/carrier/assigned-drivers' element={<AssignedDrivers />} />
                            <Route path='/admin/carriers-by-industry' element={<AdminCarriersByIndustry />} />
                            <Route path='/admin/assign-drivers/:carrierId' element={<AssignDriver />} />
                            <Route path='/admin/driver-assign' element={<DriverAssign />} />
                            <Route path='/admin/driver-assign-monitor' element={<DriverAssignMonitor />} />
                            <Route path='/carrier/package' element={<PackageSelection />} />
                            <Route path='/admin/add-driver' element={<DriverCreate />} />
                            <Route path='/admin/revenue-report' element={<Revenue />} />
                            <Route path='/admin/profile-update' element={<PendingApproval />} />
                            <Route path='/carrier/watch-demo' element={<WatchFleetyDemo />} />
                            <Route path='/carrier/live-demo-request' element={<CarrierLiveDemo />} />
                            <Route path='/carrier/payment-history' element={<PaymentHistory />} />
                            <Route path='/carrier/report-issues' element={<ReportIssues />} />
                            <Route path='/admin/carrier-demo-bookings' element={<CarrierDemoBookings />} />
                            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                            <Route path='/cookie-policy' element={<CookiePolicy />} />
                            <Route path='/terms-of-use' element={<TermsOfUse />} />
                            <Route path='/forget-password' element={<ForgotPassword />} />
                            <Route path='/reset-password' element={<ResetPassword />} />
                            <Route path='/book-demo' element={<DemoBooking />} />
                            <Route path='/salesrep/dashboard' element={<SalesrepDashboard />} />
                            <Route path='/admin/add-carrier' element={<AdminAddCarrier />} />
                            <Route path='/admin/reported-issues' element={<ReportedIssues />} />
                            <Route path='/carrier/special-payment-success' element={<SpecialPaymentSuccess />} />
                            <Route
                                path='/admin/special-package-subscribers'
                                element={<SpecialPackageSubscribedCarriers />}
                            />
                        </Routes>
                    </main>
                </div>
            </Router>
        </SubscriptionProvider>
    );
}

export default App;
